import React from 'react';
import ImageGallery from 'react-image-gallery';
import '../node_modules/react-image-gallery/styles/css/image-gallery.css';
import './Gallerie.scss';


class Gallerie extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
    };
  }
  
  componentDidMount() {
    fetch('gallery.json', {
          method: 'get',
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Request error');
        }
      })
      .then(j => this.setState({ images: j.images}))
      .catch(error => this.setState({ error: error}));

   }

  render() {
    return (<ImageGallery
      items={this.state.images}
      lazyLoad={false}
      infinite={true}
      showBullets={true}
      showFullscreenButton={true}
      showPlayButton={true}
      showThumbnails={true}
      showIndex={false}
      showNav={true}
      thumbnailPosition='bottom'
      slideDuration={450}
      slideInterval={2000}
      />
       );
  }
}

  
  export default Gallerie;


// WEBPACK FOOTER //
// ./src/Gallerie.js